import { UserMinus, X } from 'lucide-react'

interface UnsubscribeDialogProps {
  appName: string
  appDisplayName?: string
  onClose: () => void
  onConfirm: () => void
}

export default function UnsubscribeDialog({
  appName,
  appDisplayName,
  onClose,
  onConfirm,
}: UnsubscribeDialogProps) {
  const label = appDisplayName || appName

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-xl w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <UserMinus className="w-5 h-5" />
            Leave app
          </h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-secondary transition-colors"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-sm text-muted-foreground mb-4">
          Remove your access to &ldquo;{label}&rdquo;? You can ask the owner to re-share it later.
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-border hover:bg-secondary transition-colors text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg bg-destructive text-destructive-foreground hover:bg-destructive/90 transition-colors text-sm flex items-center gap-2"
          >
            <UserMinus className="w-4 h-4" />
            Unsubscribe
          </button>
        </div>
      </div>
    </div>
  )
}
